export default __webpack_public_path__ + "static/teste-funcionalidade-fa08d8386cd07e1971aed73a926c355c.png";